import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFilterErrorBoundaryMessage = () => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "quickFilter.error"
  });
};
export default QuickFilterErrorBoundaryMessage;